import React from "react";
import "./bed_room.css";
import Card from "react-bootstrap/Card";

import Button from "react-bootstrap/Button";

function bed_room(props) {
  return (
    <div>
      <div className="container">
        <div className="container-heading">
          <h2>Bed Room</h2>
          <div className="row">
            <div className="col-lg-6 container-text">
              <h3>Are you looking for unique bedroom designs and styles?</h3>
              <p>
                Then, you have arrived at the very right place to know about it.
                The Bed Room designs must be in a pristine combination of
                allurance and mesmerizing impact. Only then the functionality of
                a particular bed area style would serve you perfectly. However,
                the major query regarding artistics includes various parameters
                and measurements of several horizons. For instance, the
                affordability factor, style, additions to adorne and utilize
                space in an useful manner is the need of designing bed areas.
                Additionally , home decor must work to add on the beauty to the
                specified bedding section.
                <br />
                <br />
                Now, if you want some considerations which would provide useful
                options to you. Then, let’s have a quick observation on the
                further mentioned guide.
              </p>
            </div>
            <div className="col-lg-6">
              <div className="img">
                <img src="/img/interior/bed-1920.jpg" alt=""></img>
              </div>
            </div>
          </div>
        </div>
        <div className="button">
          <a href="/contact">
            <Button variant="success" className="button">
              
              Book Now
            </Button>
          </a>
        </div>
        <div className="container-text-text">
        <h5>Why is <strong> Bed Room</strong> decor necessary?</h5>
        <p>
          What is the best method to bring a style to the bed areas? Everybody
          would answer this question in different ways.
         <br/>
         <br/>
          The art variations including hangings and photos are usually the
          optimum way to adorn the bed area. However, some inspirations which
          can be easily pulled off are in demand by most of the people.
          Moreover, the bed regions are the personal areas in a particular
          house. That is why bedding sections must be a summation of peace,
          safety, pleasure and rejuvenation. Therefore, you must focus on
          bringing the reflection of your good mood into your personal space.
          Although, this is quite challenging to make its occurrence. So, let’s
          move forward to seek answers to various questions.
        </p>
        <h5>Which parameters are important in bed room styling?</h5>
        <p>
        There are an immense number of options which would benefit the appearance of your bed area. Obviously, you want your personal vibe around you while having rest and relaxation. Therefore, do not compromise in designing your bed section
        </p>

        <h5>Additive spaces</h5>
        <p>
        Firstly, the bed area style must contain the simple yet fancy look. The spaces must be distributed in equal sections along with the combination of compatible items.
        </p>

        <h5>Greenery all around</h5>
        <p>
        Secondly, even your bedroom has combined spaces. Nature must be at your place which would surround you with an optimistic feel. You can plant an indoor garden, flowers and plants in your bedding section for an environmental vibe.
        </p>

        <h5>Lighting system</h5>
        <p>
        One of the major alterations in bed room designing is to claim a thumbs up for making lights entered naturally. Thus, you must ensure that your house doors and windows are broadened accurately for proper light entrance.
        </p>

        <h5>Air ventilation</h5>
        <p>
        Next, the air ventilation must be excellent in order to get fresh oxygen every time you take rest. So, design your house layout accordingly.
        </p>

        <h5>What are styles for bed rooms?</h5>
        <p>
        Are you one of those who always look for advancement to appeal to the rooms of your house. Then, here are some go-to designs which would be proven satisfactory to the unique personality of your house.
        </p>
        <h5>Cottage style</h5>
        <p>
        The wooden styling of the rejuvenation room with the usage of texture and dazzling color combination is the symbol of this cottage style room. These types of bed areas are quite cozy, warm and embraced.
        </p>
        <h5>Mediterranean style</h5>
        <p>
        Secondly, if you want to embrace inspiration of authenticity with the mixture of vogue then you must go for this style for designing rooms. Moreover, this type of style offers elegance, luxury and safety all together
        </p>
        <h5>Eclectic style</h5>
        <p>
        Nextly, this type of bedding style is defined as an adaptable one. Planning of beautiful patterns, textures and colors are tied together for a marvelous look. And, any other components would compliment really great with this type of style.
        </p>
        <h5>Conclusions</h5>
        <p>
        To recapitulate, it is quite simple to read out and understand the styles and designs of different parts of your house. Although, every part of the house needs a different appealing look. So here you have observed that blending the decor and innovations together would definitely give a right style to your bed areas. Therefore, choose any style from the stacked count of house designs while keeping necessary points in your mind.
        </p>
        </div>
        <div className="container-design">
          <h1>Design</h1>
          <div className="row">
            <div className="col-lg-4">
            <Card>
                <Card.Img variant="top" src="/img/BedRoom/bed room (1).jpg" />
                
              </Card>
            </div>
            <div className="col-lg-4">
            <Card>
                <Card.Img variant="top" src="/img/BedRoom/bed room (2).jpg" />
                
              </Card>
            </div>
            <div className="col-lg-4">
            <Card>
                <Card.Img variant="top" src="/img/BedRoom/bed room (3).jpg" />
                
              </Card>
            </div>
            <div className="col-lg-4">
            <Card>
                <Card.Img variant="top" src="/img/BedRoom/bed room (4).jpg" />
                
              </Card>
            </div>
            <div className="col-lg-4">
            <Card>
                <Card.Img variant="top" src="/img/BedRoom/bed room (5).jpg" />
                
              </Card>
            </div>
            <div className="col-lg-4">
            <Card>
                <Card.Img variant="top" src="/img/BedRoom/bed room (6).jpg" />
                
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default bed_room;
